import { CreateLabelText } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/AbstractScrollableContentView";
import { VerticalLayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/layout/VerticalLayout";
import { BetData, CurrentContentTypeEntry, DeprecatedFeatureContentEntry, LabelText, SymbolsPayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/PaytableContent";
import { SymbolsContentView, alignSymbolEntries } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/SymbolsContentView";
import { BasePaytableComponent } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/BasePaytableComponent";
import { TextFromContainer } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utils";
import { convertDisplayObjectToImage } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utilsImg";
import { IOryxServiceProvider } from "@westpierstudio/core-module-oryx/game";
import { Text, Container, Sprite, DisplayObject } from "pixi.js";

export type SpreadRTPDependentResolvedPayload = {
    description?: LabelText
}


export type SpreadRTPDependentComponentPayload = {
    title?: LabelText
    symbolsPayout?: SymbolsPayout
    icons?: string[]
    spreadRTPPayload: SpreadRTPDependentResolvedPayload
    noSpreadRTPPayload: SpreadRTPDependentResolvedPayload
}

export class SpreadRTPDependentComponent extends BasePaytableComponent {
    private readonly titleTextfield?: Text;
    private readonly descriptionTextfield?: Text;
    private readonly layout: VerticalLayout;
    symbolsPayoutViewList: any;
    symbolsContent?: SymbolsContentView;
    iconsContent?: Container<Sprite>;
    icons: Container<Sprite>[] = [];

    constructor(services: IOryxServiceProvider, payload: SpreadRTPDependentComponentPayload, spread: boolean, createLabelText: CreateLabelText, name?: string) {
        super(services);

        this.layout = new VerticalLayout({gap: 10});

        if (payload.title) {
            this.titleTextfield = createLabelText(payload.title, 0.5, 0);
            this.layout.add(this.titleTextfield);
        }

        if (payload.icons) {
            this.iconsContent = this.createIconsContent(payload.icons);
            this.layout.add(this.iconsContent);
        }

        const resolvedPayload = spread ? payload.spreadRTPPayload : payload.noSpreadRTPPayload;
        if (resolvedPayload.description) {
            this.descriptionTextfield = createLabelText(resolvedPayload.description, 0.5, 0);
            this.layout.add(this.descriptionTextfield);
        }

        if (payload.symbolsPayout) {
            this.symbolsContent = new SymbolsContentView(services, [payload.symbolsPayout], {}, createLabelText, undefined);
            this.layout.add(this.symbolsContent);
        }

        if (name) {
            this.name = name;
        }

        this.layout.layout(this);
    }

    protected createIconsContent(icons: NonNullable<IconsOrDeprecatedTextures>) {
        const iconContent = new Container<Sprite>();
        iconContent.name = `icons-content-view`;
        icons.forEach(icon => {
            if (typeof icon === `string`) {
                iconContent.addChild(Sprite.from(this.services.resources.getTexture(icon)));
            } else {
                iconContent.addChild(this.services.factory.createSprite(icon));
            }
        });
        return iconContent;
    };

    onOpen(betData: BetData) {
        this.symbolsContent?.onOpen(betData);
    }

    updateLayout(width: number, height: number) {
        this.symbolsContent?.updateLayout(width, height);
        if (this.iconsContent) {
            alignSymbolEntries(this.iconsContent, width);
        }
        this.layout.layout(this);
    }

    /**
     * Return Pixi container as HTML friendly Text content.
     * Used for search functionality
     */
    async getRenderedContentAsText(): Promise< ReadonlyArray<TextFromContainer>> {

        const images = [];
        if (this.symbolsContent) {
            const symbols = await convertDisplayObjectToImage(this.services.application.renderer, this.symbolsContent, `image/png`);
            images?.push(symbols);
        }
        if (this.iconsContent) {
            const icons = await convertDisplayObjectToImage(this.services.application.renderer, this.iconsContent, `image/png`);
            images?.push(icons);
        }

        const container: TextFromContainer = { title: this.titleTextfield?.text ?? ``, content: this.descriptionTextfield?.text ?? ``, images};

        return [container];
    }
}

type IconsOrDeprecatedTextures = CurrentContentTypeEntry["icons"] | DeprecatedFeatureContentEntry["textures"];